import type { ReactNode } from "react";
import { SidebarMenuButton, SidebarMenuItem } from "../ui/sidebar";
import { cn } from "lib/utils";

type Props = {
  name: string;
  icon: ReactNode;
  active?: boolean;
  action: () => void;
  /** Contador de pendências. Some quando zero. */
  badge?: number;
};

/**
 * Item do menu lateral.
 *
 * As cores são explícitas de propósito: o componente shadcn usa
 * `bg-sidebar-accent` / `text-sidebar-foreground`, e essas variáveis nunca
 * foram definidas no index.css nem no tailwind.config — as classes não geram
 * nada. Quem pinta o item é este arquivo.
 */
const NavLink = ({ name, active, icon, action, badge }: Props) => {
  return (
    <SidebarMenuItem
      className={cn(
        "relative rounded-md transition-colors duration-200",
        active
          ? "bg-white/[0.12] text-brand-cardtext"
          : "text-brand-cardtext/75 hover:bg-white/[0.07] hover:text-brand-cardtext",
      )}
    >
      {/* Barra de destaque à esquerda: marca o item aberto sem inverter as
          cores do item inteiro, que era o que dava o flash branco. */}
      {active && (
        <span className="pointer-events-none absolute bottom-1.5 left-0 top-1.5 w-[3px] rounded-full bg-brand-primary" />
      )}
      <SidebarMenuButton
        className={cn(
          "ml-2 text-shopify-body hover:cursor-pointer",
          "hover:bg-transparent hover:text-inherit",
          "[&>svg]:h-5 [&>svg]:w-5 [&>svg]:shrink-0",
          active && "font-semibold",
        )}
        onClick={action}
      >
        {icon}
        <span className="flex-1 truncate">{name}</span>
        {!!badge && badge > 0 && (
          <span
            title={`${badge} ${badge === 1 ? "ocorrência" : "ocorrências"}`}
            className="ml-auto flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1.5 text-[10px] font-bold text-white"
          >
            {badge > 99 ? "99+" : badge}
          </span>
        )}
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
export default NavLink;
